import { ReactElement, useCallback } from 'react'
import { useFormContext } from 'react-hook-form'
import { Stack } from '@mui/material'
import type { ProjectConnectionPrioritizationDTO } from '@api/fastAPI.schemas'
import { useSnackbar } from '@ui/snackbar'
import ConnectionPrioritizationList from '../../ConnectionPrioritizationList'
import { schema } from '../schema'

interface Props {
  connections: Connection[]
  onSave: (values: ProjectConnectionPrioritizationDTO) => void
}

const OrganisationConnectionPrioritizationLists = ({
  connections,
  onSave,
}: Props): ReactElement => {
  const { getValues } = useFormContext()
  const { enqueueSnackbar } = useSnackbar()

  const handleChange = useCallback(() => {
    const values = getValues() as ProjectConnectionPrioritizationDTO
    schema
      .isValid(values)
      .then(isValid => {
        if (!isValid) {
          enqueueSnackbar('Bitte wählen Sie für jedes Szenario mindestens eine Zugverbindung', {
            variant: 'error',
          })
          return
        }
        onSave(values)
      })
      .catch(() => {
        enqueueSnackbar('Bitte wählen Sie für jedes Szenario mindestens eine Zugverbindung', {
          variant: 'error',
        })
      })
  }, [enqueueSnackbar, getValues, onSave])

  return (
    <Stack spacing={3} mt={3}>
      <ConnectionPrioritizationList
        fieldName="inner_inner"
        title="Innen-Innen"
        availableConnections={connections}
        data-cy="organisation-inner"
        onChange={handleChange}
      />
      <ConnectionPrioritizationList
        fieldName="inner_foundation"
        title="Innen-Fundament"
        availableConnections={connections}
        data-cy="organisation-inner-foundation"
        onChange={handleChange}
      />
      <ConnectionPrioritizationList
        fieldName="outer_outer"
        title="Außen-Außen"
        availableConnections={connections}
        data-cy="organisation-outer"
        onChange={handleChange}
      />
      <ConnectionPrioritizationList
        fieldName="outer_foundation"
        title="Außen-Fundament"
        availableConnections={connections}
        data-cy="organisation-outer-foundation"
        onChange={handleChange}
      />
    </Stack>
  )
}

export default OrganisationConnectionPrioritizationLists
